module.exports = __webpack_public_path__ + "img/cs-baseSucc-2.586f78c6.jpg";